import React from 'react';
import { useStyletron } from 'baseui';
import { colorWithOpacity } from '../../../../../common/utils/color-with-opacity';
import { ANNOTATION_TINT_OPACITY, RELATIONSHIP_ROW_VARIANT } from '../../../constants/frame-timeline-v4';
import type { RelationshipRowDescriptorT } from '../../../types/frame-timeline-v4';
import { getSpanAtFrame } from '../../../utils/frame-timeline-v4';
import { SpanPiece } from './span-piece';
import { SpanValueLabel } from './span-value-label';
type RelationshipCellPropsT = {
  row: RelationshipRowDescriptorT;
  frame: number;
  cellWidth: number;
  isSelected?: boolean;
};
export const RelationshipCell = React.memo(function RelationshipCell({
  row,
  frame,
  cellWidth,
  isSelected = false
}: RelationshipCellPropsT) {
  const [, theme] = useStyletron();
  const frameIndex = frame - 1;
  const result = getSpanAtFrame(row.spans, frameIndex);
  if (!result) {
    return null;
  }
  const {
    span,
    position
  } = result;
  const base = row.color ?? theme.colors.borderSelected;
  const isDraft = row.variant === RELATIONSHIP_ROW_VARIANT.DRAFT;
  return <SpanPiece position={position} cellWidth={cellWidth} overrides={{
    fillColor: colorWithOpacity(base, ANNOTATION_TINT_OPACITY),
    borderColor: isDraft || isSelected ? base : 'transparent',
    handleColor: base,
    borderDashed: isDraft
  }}>
      <SpanValueLabel value={span.value} framesIntoSpan={frameIndex - span.start} position={position} cellWidth={cellWidth} />
    </SpanPiece>;
});